import React from 'react';

export default React.createContext<mapkit.Map | null>(null);
